import React from "react";
import { transformComma } from "../../../utils/validator/comma";

const PensionSummaryInfo = ({ data, data2 }) => {
  if (!data) {
    return <p>데이터가 없습니다.</p>;
  }

  const getValue = (key) => transformComma(data[key] || "0");

  return (
    <table className="summary-table">
      <tbody>
        <tr>
          <td>당월분 인원(명)</td>
          <td>{getValue("sPrsnCnt")} 명</td>
          <td>월보험료 계(원)</td>
          <td>{getValue("sAmt")} 원</td>
          <td>사용자부담금 계(원)</td>
          <td>{getValue("eAmt")} 원</td>
          <td>본인기여금 계(원)</td>
          <td>{getValue("ePay")} 원</td>
        </tr>
        {/* <tr>
          <td>소급분 인원(명)</td>
          <td>{data2?.list?.length || 0} 명</td>
          <td>월보험료 계(원)</td>
          <td>{getValue("sAmt")} 원</td>
          <td>사용자부담금 계(원)</td>
          <td>{getValue("eAmt")} 원</td>
          <td>본인기여금 계(원)</td>
          <td>{getValue("ePay")} 원</td>
        </tr> */}
      </tbody>
    </table>
  );
};

export default PensionSummaryInfo;
